import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["sellerId", "seller_id"];
var parseSellerId = function parseSellerId() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var sellerId = _ref.sellerId,
    sellerIdQS = _ref.seller_id,
    params = _objectWithoutProperties(_ref, _excluded);
  var uniqueSellerId = sellerId || sellerIdQS;
  if (Array.isArray(uniqueSellerId)) {
    var _uniqueSellerId = uniqueSellerId;
    var _uniqueSellerId2 = _slicedToArray(_uniqueSellerId, 1);
    uniqueSellerId = _uniqueSellerId2[0];
  }
  return _extends({}, params, uniqueSellerId ? {
    sellerId: uniqueSellerId
  } : {});
};
export default parseSellerId;